import { 
    Star, 
    ShieldCheck, 
    Leaf, 
    Package, 
    ChevronRight,
    Info,
    ArrowRight
  } from 'lucide-react';
const ProductCategories = () => {
    const categories = [
      {
        name: "Daily Pads",
        description: "Experience everyday comfort with our breathable organic cotton daily pads, designed for reliable protection and peace of mind.",
        icon: Package,
        features: ["Breathable", "Ultra-Soft", "Natural"]
      },
      {
        name: "Night Pads",
        description: "Rest easy with our extra-absorbent night pads, providing complete coverage and comfort throughout your sleep.",
        icon: Leaf,
        features: ["Extra Coverage", "Super Absorbent", "Leak Guard"]
      },
      {
        name: "Liners",
        description: "Stay fresh with our ultra-thin organic liners, perfect for light days and daily freshness you can trust.",
        icon: ShieldCheck,
        features: ["Ultra Thin", "Flexible", "Discrete"]
      }
    ];
  
    return (
      <div className="max-w-7xl mx-auto p-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Our Product Range
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover our collection of thoughtfully designed organic cotton products for your comfort and wellbeing
          </p>
        </div>
  
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, idx) => (
            <div 
              key={idx}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all overflow-hidden"
            >
              {/* Decorative background element */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#679729]/5 rounded-bl-full transform group-hover:scale-150 transition-transform duration-500" />
              
              <div className="relative z-10">
                <div className="p-3 bg-[#679729]/10 rounded-xl inline-block mb-6">
                  <category.icon className="w-6 h-6 text-[#679729]" />
                </div>
  
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  {category.name}
                </h3>
                
                <p className="text-gray-600 mb-6">
                  {category.description}
                </p>
  
                <div className="space-y-2">
                  {category.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm text-gray-500">
                      <Info size={16} className="text-[#679729]" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
                <button className="mt-6 inline-flex items-center gap-2 text-[#679729] font-medium hover:gap-3 transition-all">
                  View Details <ChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

export default ProductCategories;